import React, { useEffect, useRef, useState } from "react";
import { Button, Grid, TextField, Box, Stack } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import Modal from "../../Components/Modal";
import { accessProfile } from "../../Requests";
import useGlobalContext from "../../Hooks/useGlobalContext";
import { useSnackbar } from "notistack";

interface IAddProfileProps {
  reloadResourceTable: () => void;
}

const AddProfile: React.FC<IAddProfileProps> = ({ reloadResourceTable }) => {
  const { setLoading, loading } = useGlobalContext();
  const { enqueueSnackbar } = useSnackbar();

  const inputRef = useRef<HTMLInputElement>(null);

  const [openModal, setOpenModal] = useState(false);
  const [descricaoPerfil, setDescricaoPerfil] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
    setDescricaoPerfil("");
    setMessage("");
    setError(false);
  };

  const handleCloseModal = () => setOpenModal(false);

  const handleChangeDescricaoPerfil = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDescricaoPerfil(event.target.value);
    if (error) {
      setError(false);
      setMessage('');
    }
  };

  const handleSaveNewAccessProfile = async () => {
    setLoading?.(true);

    const result = await accessProfile.post({
      description: descricaoPerfil,
    });

    if (result?.errors || !result?.description) {
      setError(true);
      setMessage(result?.message || "Erro ao criar perfil");
      enqueueSnackbar(result?.message || "Erro ao criar perfil", { variant: "error" });
    } else {
      enqueueSnackbar("Novo perfil de acesso adicionado com sucesso!", { variant: "success" });
      reloadResourceTable();
      handleCloseModal();
    }

    setLoading?.(false);
  };

  useEffect(() => {
    if (openModal) {
      setTimeout(() => inputRef?.current?.focus(), 100);
    }
  }, [openModal]);

  return (
    <Grid item xs={12} display="flex" justifyContent="flex-end">
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddCircleIcon />}
        onClick={handleOpenModal}
        aria-label="Adicionar novo perfil de acesso"
      >
        Adicionar
      </Button>

      <Modal
        title="Adicionar novo perfil de acesso"
        open={openModal && !loading}
        closeModal={handleCloseModal}
        maxWidth="sm"
      >
        <Box component="form" noValidate>
          <Stack spacing={3}>
            <TextField
              inputRef={inputRef}
              label="Descrição do perfil"
              variant="filled"
              fullWidth
              value={descricaoPerfil}
              onChange={handleChangeDescricaoPerfil}
              error={error}
              helperText={message}
              autoComplete="off"
              autoFocus
            />
            <Box display="flex" justifyContent="flex-end">
              <Button
                variant="contained"
                color="primary"
                startIcon={<SaveAsIcon />}
                onClick={handleSaveNewAccessProfile}
              >
                Salvar
              </Button>
            </Box>
          </Stack>
        </Box>
      </Modal>
    </Grid>
  );
};

export default AddProfile;
